import React from "react";
import { IVehicleResult, ICoverageResult } from "../classes/Domain";
import * as _ from 'lodash';
import Utilities from "../classes/Utilities";

interface IProps {
	vehicleRate: IVehicleResult
}

interface IState {
	coverageCodes: Array<string>,
	fees: Array<ICoverageResult>
}

class CoveragesOverview extends React.Component<IProps, IState> {
	constructor(props: IProps) {
        super(props);
		this.state = {
			coverageCodes: [],
			fees: []
        };
	}

	componentDidMount() {
		const covs = _.union(
			_.map(this.props.vehicleRate.liabilityCoverages, "code"),
			_.map(this.props.vehicleRate.vehicleCoverages, "code")
		);

		this.setState({ ...this.state, coverageCodes: covs, fees: this.props.vehicleRate.fees });
	}

	getCoverage(vehicleResult: IVehicleResult, coverageCode: string) {
		let coverage = _.find(vehicleResult.liabilityCoverages, c => c.code === coverageCode);
		return coverage ? coverage : _.find(vehicleResult.vehicleCoverages, c => c.code === coverageCode);
	}	

	renderCoverage(coverageCode: string) {
		let coverage = this.getCoverage(this.props.vehicleRate, coverageCode);
		return !coverage
			? null
			: <div className="item">
				<label className="left-cell">					
					{coverage.title ? coverage.title : "No Coverage"}
				</label>
				<label className="right-cell"><strong>{coverage.amt ? Utilities.formatCurrency(coverage.amt) : ""}</strong></label>
			</div>
    }

    render() {
        return (
			<div className="vehicle-coverages">
				<div className="vehicle-name">
					<strong className="vehicle-title">{`${this.props.vehicleRate.year} ${this.props.vehicleRate.make} ${this.props.vehicleRate.model}`}</strong>
				</div>

				{this.state.coverageCodes.map((coverageCode, idx, arr) => (
					<div className="coverage" key={Utilities.uniqueId()}>
						<div className="coverage-name">
							<div>{coverageCode}</div>
						</div>
						{this.renderCoverage(coverageCode)}
					</div>
				))}

				{this.state.fees.map((fee, idx, arr) => (
					<div className="coverage" key={Utilities.uniqueId()}>
						<div className="item">
							<label className="left-cell text-uppercase">
								{fee.title}
							</label>
							<label className="right-cell"><strong>{fee.amt ? Utilities.formatCurrency(fee.amt) : ""}</strong></label>
						</div>
					</div>
				))}

				<div className="item total">
					<label className="left-cell">TOTAL</label>
					<label className="right-cell">{Utilities.formatCurrency(this.props.vehicleRate.total)}</label>
				</div>
			</div>
        );
    }
}

export default CoveragesOverview;